/* eslint-disable no-unused-vars */
import Stripe from "./modules/stripe.js";
import Firebase from "./modules/firebase.js";
import Admin from "./modules/admin.js";

export const STRIPE_API_BASE = process.env.VUE_APP_STRIPE_API_URL;
export const STRIPE_PRIVATE_KEY = process.env.VUE_APP_STRIPE_PRIVATE_KEY;

export const FCM_SERVER_KEY = process.env.VUE_APP_FCM_SERVER_KEY;
export const FCM_BASE_URL = process.env.VUE_APP_FCM_BASE_URL;

export default function Api(store) {
  return {
    stripeBaseUrl: STRIPE_API_BASE,
    token: null,
    stripe: Stripe(store),
    firebase: Firebase(store),
    admin: Admin(store)
  };
}

export function dispatchError(store, error) {
  store.dispatch("globalErrorMessage", {
    message: error,
    type: "error"
  });
}

export function stripeConfig(store) {
  return {
    headers: {
      Accept: "application/x-www-form-urlencoded;charset=utf-8",
      "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      Authorization: `Bearer ${STRIPE_PRIVATE_KEY}`
    }
  };
}

export function firebaseConfig(store) {
  return {
    headers: {
      "content-type": "application/json",
      Authorization: `key=${FCM_SERVER_KEY}`
    }
  };
}
